import * as React from 'react';
import { Props } from '../Group';
import { Field } from '../../../../../../Passenger/components/Field/Field';
import { useTheme } from '../../../../../../theme';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useConfig } from '../../../../../../context';
import Link from '../../../../../../Link';
import { useEffect } from 'react';
import { useForm } from 'react-final-form';
import { Switch } from '@shared/ui';
import { SafeHtml } from '@shared/ui';

const LoyaltyGroup: React.FC<Props> = props => {
	const [open, setOpen] = React.useState(!!props.fields[0]?.defaultValue);

	const groupTheme = useTheme('PassengerForm').Group;
	const theme = useTheme('PassengerForm').LoyaltyGroup;
	const { t } = useTranslation('Passenger');
	const config = useConfig().global.companyInfo;
	const form = useForm();

	useEffect(() => {
		if (!!props.fields[0].defaultValue) {
			setOpen(true);
		}
	}, [props.fields[0]?.defaultValue]);

	useEffect(() => {
		if (!open) {
			form.change(props.fields[0].name, '');
		}
	}, [open]);

	const onToggle = () => {
		setOpen(!open);
	};

	return (
		<div className={cn(groupTheme.container, theme.container_loyalty, { [theme.withIcons]: !!props.groupIcon })}>
			{props.groupIcon && <div className={groupTheme.icon}>{props.groupIcon}</div>}

			<div className={cn(theme.loyalty_switch, { [theme.loyalty_switch_open]: open })}>
				<Switch
					checked={open}
					onChange={onToggle}
					label={t('I have a loyalty card')}
					labelPosition="right"
					disabled={props.fields[0].readonly || props.disabled}
				/>

				{!open && (
					<p className={theme.loyalty__desc}>
						{t(`Don't have a card yet?`)}{' '}
						<Link
							target="_blank"
							action={
								props.onSignUpLoyaltyProgram
									? props.onSignUpLoyaltyProgram
									: config.loyaltyProgramRegistrationUrl
							}
						>
							<SafeHtml tag="span" html={t('Register now')} />
						</Link>
					</p>
				)}
			</div>

			<div className={theme.loyalty} style={{ display: open ? 'block' : 'none' }}>
				<Field
					field={props.fields[0]}
					passengerId={props.passengerId}
					passengerType={props.passengerType}
					disabled={props.fields[0].readonly || props.disabled}
				/>
			</div>
		</div>
	);
};

export default LoyaltyGroup;
